<script>
	import FixedScore from './FixedScore.svelte';

	export let score;
    $: [first, second] = score.split('/').map((part) => part.replace('+', ''));

</script>

<div class="dual-score">
	<FixedScore score={first} right={1.5} />
	<FixedScore score={second} right={0} />
</div>

<style lang="scss">
	.dual-score {
		position: absolute;
		width: min-content;
		height: min-content;
		top: -0.1em;
		right: 0.45em;
	}
</style>